import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "formatStatus",
  standalone: true,
})
export class FormatStatusPipe implements PipeTransform {
  transform(value: string): string {
    switch (value) {
      case "WaitResponse":
        return "Wait Response";
      case "Answered":
        return "Answered";
      case "Resolved":
        return "Resolved";
      case "Open":
        return "Open";
      default:
        return "Unknown";
    }
  }
}
